exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".payment-event-details{background-color:#292b2c!important;color:#fff;padding:1rem 1rem!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-action/payment-action.component.css"],"names":[],"mappings":"AAAA,uBACE,mCAAqC,WACxB,2BACiB,CAC/B","file":"payment-action.component.css","sourcesContent":[".payment-event-details {\n  background-color: #292b2c !important;\n  color: white;\n  padding: 1rem 1rem !important;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-action/payment-action.component.css
// module id = R0p8
// module chunks = 0